<template>
    <generic-crud :service='service' labelNome='nome_editora'></generic-crud>
</template>
<script>

import GenericCrud from '../components/GenericCrud'
import EditoraService from '../services/editora-service'

export default {

  components: {
    GenericCrud
  },
  data () {
    return {
      service: EditoraService
    }
  }

}
</script>

